<template>
  <section style="background-color: #FFFFFF" >
    <section v-for="order in orders" :key="order.id" class="pdf-item">
      <table>
        <tr>
          <td colspan="2">
            <div class="d-flex">
              <div style="padding: 10px; width: 70%">
                <h5>Mặc định</h5>
                <h6>Website: https://crm.ity.vn/</h6>
                <h6>Hotline: 0999999999</h6>
                <h6>Địa chỉ: Mặc định</h6>
              </div>
              <div>
                <div style="width: 30%">
                  <barcode :value="order.id" height="30" width="1" fontSize="10">
                    Show this if the rendering fails.
                  </barcode>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td rowspan="2">
            <div style="padding: 10px">
              Mã Đơn Hàng: {{ order.id }}
            </div>
          </td>
          <td>
            <div style="padding: 10px">
              Người nhận: {{ order.customer.name }}
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div style="padding: 10px">
              Địa chỉ: {{ order.customer.address }}
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div style="padding: 10px">
              Tổng thu: {{ order.price }}
            </div>
          </td>
          <td>
            <div style="padding: 10px">
              SĐT: {{ order.customer.phone }}
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div style="padding: 10px">
            </div>
          </td>
          <td>
            <div style="padding: 10px">
            </div>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <div style="padding: 10px">
              Ghi chú:
            </div>
          </td>
        </tr>
      </table>
    </section>
  </section>
</template>

<script>
import VueBarcode from 'vue-barcode'

export default {
  name: 'OrderPrint',
  components: {
    'barcode': VueBarcode,
  },
  props: {
    orders: {
      type: Array,
      default: () => [],
      required: true
    },
  },
}
</script>

<style scoped>
table, th, td {
  border: 1px solid black;
}

table {
  width: 80%;
}

td {
  width: 50%;
}

.pdf-item {
  height: 793px;
  margin-top: 2px;
}

section {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderPrint.vue